export default __webpack_public_path__ + "static/media/icon-estimated-cost.693960d8.svg";